module.exports = __webpack_public_path__ + "static/img/shuiBd5.28a2d89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuiBrand/shuiBd5.png
// module id = u5k2
// module chunks = 0